import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronRight, ArrowUpRight } from "lucide-react";
import StatusBadge from "@/components/StatusBadge";
import { fmtNaira, dueLabel, settlementMeta } from "@/lib/format";

function initials(name) {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  return (parts[0][0] + (parts[1] ? parts[1][0] : "")).toUpperCase();
}

export default function DebtCard({ debt, onRemind }) {
  const navigate = useNavigate();
  const iOwe = (debt.direction || "owed_to_me") === "i_owe";
  const isPaid = debt.status === "paid";
  const sm = isPaid ? settlementMeta(debt.settlement_status) : null;
  return (
    <button
      data-testid={`debt-card-${debt.id}`}
      onClick={() => navigate(`/debt/${debt.id}`)}
      className="w-full text-left bg-card rounded-2xl border border-border p-4 flex items-center gap-3 transition-all active:scale-[0.99] hover:border-primary/30 hover:shadow-sm"
    >
      <div className={`h-11 w-11 shrink-0 rounded-full font-display font-bold flex items-center justify-center ${iOwe ? "bg-foreground/5 text-foreground" : "bg-secondary text-primary"}`}>
        {initials(debt.person_name)}
      </div>
      <div className="min-w-0 flex-1">
        <div className="flex items-center justify-between gap-2">
          <p className="font-semibold text-foreground truncate flex items-center gap-1.5">
            {debt.person_name}
            {iOwe && (
              <span className="inline-flex items-center gap-0.5 rounded-full bg-foreground/5 px-1.5 py-0.5 text-[10px] font-bold text-foreground/70">
                <ArrowUpRight className="h-3 w-3" /> You owe
              </span>
            )}
          </p>
          <p className="font-display font-bold text-foreground tabular shrink-0">
            {fmtNaira(debt.outstanding_amount, debt.currency)}
          </p>
        </div>
        <div className="mt-1 flex items-center justify-between gap-2">
          {isPaid ? (
            <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold ${sm.tone === "emerald" ? "bg-emerald-100 text-emerald-800 border-emerald-200" : sm.tone === "amber" ? "bg-amber-100 text-amber-800 border-amber-200" : "bg-slate-100 text-slate-700 border-slate-200"}`}>
              {sm.label}
            </span>
          ) : (
            <StatusBadge status={debt.display_status} currency={debt.currency} />
          )}
          <span className="text-xs text-muted-foreground truncate">{dueLabel(debt)}</span>
        </div>
      </div>
      <ChevronRight className="h-5 w-5 text-muted-foreground shrink-0" />
    </button>
  );
}
